import React from 'react';
import { ActionIcon, Table } from '@mantine/core';
import { IconPencil, IconTrash } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { IcapServerDto } from '@/services/api/dlpSettingsApiArea/types';
import classes from './styles.module.css';

interface ServersTableProps {
  servers: IcapServerDto[];
  onEdit: (server: IcapServerDto, index: number) => void;
  onDelete: (index: number) => void;
}

export const ServersTable = ({ servers, onEdit, onDelete }: ServersTableProps) => {
  const { t } = useTranslation();

  if (servers.length === 0) return null;

  return (
    <div className={classes.tableContainer}>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t('dlp.server.tableAddress')}</Table.Th>
            <Table.Th>{t('dlp.server.tablePort')}</Table.Th>
            <Table.Th>{t('dlp.server.tableReqmod')}</Table.Th>
            <Table.Th>{t('dlp.server.tableRespmod')}</Table.Th>
            <Table.Th style={{ width: '100px' }}>{t('dlp.server.tableActions')}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {servers.map((server, index) => (
            <Table.Tr key={index}>
              <Table.Td>{server.Host}</Table.Td>
              <Table.Td>{server.Port}</Table.Td>
              <Table.Td>{server.ReqmodService}</Table.Td>
              <Table.Td>{server.RespmodService}</Table.Td>
              <Table.Td>
                <div className={classes.actions}>
                  <ActionIcon variant="subtle" color="gray" onClick={() => onEdit(server, index)}>
                    <IconPencil size={16} />
                  </ActionIcon>
                  <ActionIcon variant="subtle" color="red" onClick={() => onDelete(index)}>
                    <IconTrash size={16} />
                  </ActionIcon>
                </div>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </div>
  );
};
